/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ReminderUserInfo } from './reminderUserInfo';


export interface SendReminderInformation { 
    description?: string;
    taskId?: string;
    userData?: Array<ReminderUserInfo>;
}

